import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: "1d63b3ef-de58-4ffd-876a-3466d647c3ed",
        authority: "https://login.microsoftonline.com/97bccc2b-6fcd-4786-adad-3f8cf9ad5bc9",
        redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
    },
    cache: {
        cacheLocation: "sessionStorage",
    },
};

export const loginRequest: PopupRequest = {
    scopes: ["User.Read", "profile", "email", "openid"],
};

export const apiConfig = {
    baseUrl: process.env.REACT_APP_API_URL || "",
};
